import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SITE } from '../lib/site';
import { POPULAR_PAIRS } from '../lib/content';
import { Icon } from './Icon';
import { useT } from '../i18n';

export function Footer() {
  const t = useT();
  const year = new Date().getFullYear();
  const [torOnion, setTorOnion] = useState<string | null>(null);

  useEffect(() => {
    let active = true;
    fetch('/api/info')
      .then((r) => (r.ok ? r.json() : null))
      .then((json) => {
        const onion = json?.data?.torOnion;
        if (active && onion && typeof onion === 'string' && onion.endsWith('.onion')) {
          setTorOnion(onion);
        }
      })
      .catch(() => {
        // Tor mirror not configured yet, hide the link
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <footer className="site-footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <Link to="/" className="brand">
              <img className="brand-mark" src="/logo-mark.png" alt="" aria-hidden="true" />
              <span className="brand-name">
                ShieldMyAss
              </span>
            </Link>
            <div className="footer-status">
              <span className="fs-dot" />
              {t.footer.allSystemsOperational}
            </div>
            <p>{t.footer.brandDesc}</p>
            <div className="footer-social">
              <a href="https://t.me/swapmespace" target="_blank" rel="noopener noreferrer" aria-label="Telegram">
                <Icon name="telegram" />
              </a>
              <a href="https://twitter.com/swapmespace" target="_blank" rel="noopener noreferrer" aria-label="Twitter / X">
                <Icon name="twitter" />
              </a>
              <a href={`mailto:${SITE.email}`} aria-label="Email">
                <Icon name="mail" />
              </a>
              {torOnion && (
                <a
                  href={`http://${torOnion}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Tor mirror"
                  title={`Tor mirror: ${torOnion}`}
                >
                  <Icon name="lock" />
                </a>
              )}
            </div>
            {torOnion && (
              <p style={{ fontSize: '0.75rem', opacity: 0.7, marginTop: '0.5rem', wordBreak: 'break-all' }}>
                Tor: <a href={`http://${torOnion}`} style={{ color: 'inherit' }}>{torOnion}</a>
              </p>
            )}
          </div>

          <div className="footer-col">
            <h4>{t.footer.colProduct}</h4>
            <ul>
              <li><Link to="/how-it-works">{t.nav.howItWorks}</Link></li>
              <li><Link to="/fees">{t.footer.feesRates}</Link></li>
              <li><Link to="/coins">{t.footer.supportedCoins}</Link></li>
              <li><Link to="/docs">API Docs</Link></li>
              <li><Link to="/">{t.footer.launchExchange}</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>{t.footer.colPairs}</h4>
            <ul>
              {POPULAR_PAIRS.slice(0, 5).map((p) => (
                <li key={p.label}>
                  <Link to={`/exchange/${p.from}-to-${p.to}`}>{p.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-col">
            <h4>{t.footer.colCompany}</h4>
            <ul>
              <li><Link to="/about">{t.nav.about}</Link></li>
              <li><Link to="/faq">{t.nav.faq}</Link></li>
              <li><Link to="/contact">{t.nav.support}</Link></li>
              <li><Link to="/privacy">{t.pages.privacy.title}</Link></li>
              <li><Link to="/terms">{t.pages.terms.title}</Link></li>
              <li><Link to="/aml-kyc-policy">AML / KYC Policy</Link></li>
            </ul>
          </div>
        </div>

        <div className="footer-disclaimer">{t.footer.disclaimer}</div>

        <div className="footer-bottom">
          <span>© {year} {SITE.name}. {t.footer.copyright}</span>
          <div className="links">
            <Link to="/privacy">{t.pages.privacy.title}</Link>
            <Link to="/terms">{t.pages.terms.title}</Link>
            <Link to="/aml-kyc-policy">AML / KYC</Link>
            <Link to="/docs">API</Link>
            <a href={`mailto:${SITE.email}`}>{SITE.email}</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
